import { TeamMemberForm } from "../../../TeamMemberForm";

import { useTeamMemberUpdateMutation } from "./TeamMemberUpdateMutation";
import type { TeamMemberUpdateVariables } from "./TeamMemberUpdateMutation";
import { useTeamMemberEditQuery } from "./TeamMemberEditQuery";

interface Props {
  teamMemberSlug: string | undefined;
  onSave: () => void;
}

const TeamMemberEdit = ({ teamMemberSlug, onSave }: Props) => {
  const { data, loading } = useTeamMemberEditQuery({
    variables: { slug: teamMemberSlug ?? "" },
  });

  const [saveTeamMember] = useTeamMemberUpdateMutation();

  const handleSave = async (teamMember: TeamMemberUpdateVariables) => {
    let order = teamMember.order;

    // If order is a string, we need to parse as an int before saving
    if (typeof order === "string") {
      order = parseInt(order);
    }

    await saveTeamMember({
      variables: {
        ...teamMember,
        order,
      },
    });

    onSave();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return <TeamMemberForm teamMember={data?.teamMember} onUpdate={handleSave} />;
};

export { TeamMemberEdit };
